import styles from './collaborations.module.scss';
import animations from "@components/shared/animation/animations.module.scss";
import SharedAnimation from "@components/shared/animation";
import Image from "next/image";
import { CollaborationsSection } from "@components/projects/social-luke/social-luke.state";

type CollaborationProps = {
    collaborations: CollaborationsSection;
}

const Collaborations = ({collaborations}: CollaborationProps ): JSX.Element => {
    return (<>
        <SharedAnimation render={(ref) => (
            <div className={styles.container}>
                <section ref={ref} className={`${styles.section} ${animations.scroll__animation}`}>
                    <h2 className={styles.collaborations__title}>{collaborations.title}</h2>

                    <div className={styles.collaborations__infoWrapper}>
                        <div className={styles.collaborations__infoMain}>
                            <p> {collaborations.mainSection.title} </p>

                            {collaborations.mainSection.points.map(point => (
                                <div className={styles.collaborations__infoItem} key={point.title}>
                                    <Image src={point.icon} width={24} height={18} alt={point.title}/>
                                    <p className={styles.collaborations__infoText}>{point.title}</p>
                                </div>
                            ))}
                        </div>

                        <div className={styles.collaborations__infoSecondary}>
                            {collaborations.secondarySection.map((section) => (
                                <div key={section.title}
                                     className={`${styles.collaborations__infoMain}`} style={{
                                    'borderRight': 'unset'
                                }}>
                                    <p> {section.title} </p>

                                    {section.points.map(point => (
                                        <div className={styles.collaborations__infoItem} key={point.title}>
                                            <Image src={point.icon}
                                                   width={24} height={18}
                                                   alt={point.title}/>
                                            <p className={styles.collaborations__infoText}>{point.title}</p>
                                        </div>
                                    ))}
                                </div>
                            ))}
                        </div>

                    </div>
                </section>
            </div>
        )}/>
    </>);
}

export default Collaborations;